module.exports = __webpack_public_path__ + "static/media/logo.219a76ea.png";